import { DynamicComponents } from '@/templates';

import { getZona, getZonas } from '@/graphql/queries';
import { dynamicComponentsTransformer } from '@/graphql/transformers';
import { routes } from '@/lib';

const Zona = ({ page: { attributes } }: any) =>
  attributes?.Content?.map(({ __typename, ...props }: any, index: number) => (
    <DynamicComponents
      type={__typename}
      {...props}
      key={`${__typename}-${index}`}
    />
  ));

export const getStaticProps = async ({ params, preview = false }: any) => {
  const { zonas, menus, preFooter } = await getZona(
    routes.zones.zone(params.slug),
    preview
  );
  const attributes = zonas?.[0] || null;

  if (attributes?.Content)
    attributes.Content = dynamicComponentsTransformer(attributes.Content);

  return {
    props: {
      page: {
        theme: 'light',
        langcode: {
          id: 'es',
        },
        attributes,
        menu: menus || [],
        preFooter: preFooter || null,
        preview,
      },
    },
    notFound: zonas.length == 0,
    revalidate: process.env.NEXT_PUBLIC_REVALIDATE
      ? parseInt(process.env.NEXT_PUBLIC_REVALIDATE)
      : 1000,
  };
};

export async function getStaticPaths() {
  const { zonas } = await getZonas();

  return {
    paths: zonas.map((itm: any) => itm.slug),
    fallback: 'blocking',
  };
}

export default Zona;
